<template>
  <div>
    <div class="m-t-4 m-b-3 color-1">
      <button 
        class="btn btn-outlined mv-4 mr-2" 
        :class="{'active': menunum === 0}"
        @click="menunum = 0">
        <span class="p-x-8 text-x3">Шаблоны</span>
      </button>
      <button 
        class="btn btn-outlined mv-4" 
        :class="{'active': menunum === 1}"
        @click="menunum = 1">
        <span class="p-x-8 text-x3">Четверти</span>
      </button>
    </div>
    <div>
      <div v-if="menunum == 0">
        <TimetableSample :id="id"/>
      </div>
      <div v-else-if="menunum == 1">
        <TimetableByDate :id="id"/>
      </div>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, errorNotify } from "@/plugins/functions";

export default {
  props: ["id"],
  name: "TimetableTabs",
  data: () => ({
    menunum: 0,
    timetable: [],
    currentSchedule: null,
    itemLink: "business/groups/timetable",
    item: null,
    fields: [],
    quarters: null,
    seasonId: null,
  }),
  components: {
    "TimetableSample": () => import("./Timetable/TimetableSample"),
    "TimetableByDate": () => import("./Timetable/TimetableByDate"),
  },

  async created() {
  },
  mounted(){
    
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
  },
};
</script>
<style>
</style>
